<template>
    <div>
       <h2>Add Reel</h2>
       <div class="m-4">
           <div class="form-group m-5">
             <label for="">Reel Video </label>
             <input type="file" class="form-control-file" name="" id="" placeholder="" aria-describedby="fileHelpId" ref="file" @change="handleUploadFile">
             <small id="fileHelpId" class="form-text text-muted">apccept:mp4 videos only</small>
           </div>
           <div class="m-5">
               Video Description
               <vs-input class="w-full"  v-model="content" />
           </div>
           <div class="m-5">
               Tag to Movie :
                  <vSelect :filterable="false" :multiple="false" v-model="items" @search="search" :options="$store.state.movies.search" placeholder="select movies">
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <img :src="`${$baseUrl}/uploads/movies/thumbs/${option.poster}`" />
                            {{ option.en_title }} - {{ option.year }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            <img :src="`${option.poster}`" />
                            {{ option.en_title }}
                        </div>
                    </template>
                </vSelect>
           </div>
           <div class="m-5">
               <vs-button @click="save">save</vs-button>
           </div>
            

       </div>
    </div>
</template>
<script>
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
export default {
    components: {
            vSelect
        },
    data() {
        return {
            items:[],
            content:'',
            video:''
        }
    },
    created() {
        
    },
    methods: {
        handleUploadFile(){
            this.video = this.$refs.file.files[0];
        },
         search(query, loading) {
                this.$store.dispatch('movies/search', query)
            },
            save(){
                this.$vs.loading();
                const data =new FormData();
                data.append('content',this.content);
                data.append('target_id',this.items.id);
                data.append('video',this.video);
                 this.axios.post(`${this.$apiUrl}/reels`, data).then(res => {
                     this.$vs.loading.close();
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Reel Addedd',
                            text: ''
                        })
                        this.$router.push({name:'reels'})
                    }
                }).catch(err =>{
                    this.$vs.loading.close();
                 this.$vs.notify({
                            color: 'danger',
                            title: 'Error When Add',
                            text: ''
                        })
              });
            }
    },
}
</script>
<style lang="scss" scoped>
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

        .v-select {
            width: 100%;
            margin-top: 10px;
        }

    }

    img {
        height: auto;
        max-width: 2.5rem;
        margin-right: 1rem;
    }

    .d-center {
        display: flex;
        align-items: center;
    }

    .selected img {
        width: auto;
        max-height: 23px;
        margin-right: 0.5rem;
    }
</style>